'use strict';
import {settings} from '../../variables.js'
var angularTemplatesBase = settings.angularTemplatesBase
var staticBase = settings.staticBase

angular.
module('contacts')
.component('shOrderForm', {
    templateUrl: angularTemplatesBase+'contacts/shelf-order.template.html?1',
    controller: ['ShelfOrder', function ShOrderForm(ShelfOrder) {
        var self = this;

        self.contact = ShelfOrder.get();
        self.step = 'start';
        self.disable_btn = false;

        self.next_step = function(step){
            self.step = step;
        }

        self.send_form = function(){
            self.disable_btn = true;
            self.contact.$save(
                function(response){
                    self.step = 'complete';
                    self.disable_btn = false;
                    ym(44803777, 'reachGoal', 'SENT_MESSAGE');
                },
                function(response){
                    self.errors = response.data;
                    self.disable_btn = false;
                }
            );
        }

    }]
})
.component('contactformopt', {
    templateUrl: angularTemplatesBase+'contacts/contacts-opt.template.html?2',
    controller: ['$routeParams', 'ContactOpt', '$location', '$cookies', function ContactFormOptCtrl($routeParams, ContactOpt, $location, $cookies) {
        var self = this;

        self.contact = ContactOpt.get();
        self.step = 'start';
        self.disable_btn = false;

        self.next_step = function(step){
            self.step = step;
        }

        self.send_form = function(){
            self.disable_btn = true;
            self.contact.$save(
                function(response){
                    self.step = 'complete';
                    self.disable_btn = false;
                    ym(44803777, 'reachGoal', 'SENT_MESSAGE');
                },
                function(response){
                    self.errors = response.data;
                    self.disable_btn = false;
                }
            );
        }

    }]
})
.component('contactform', {
    templateUrl: angularTemplatesBase+'contacts/contacts.template.html?2',
    controller: ['$routeParams', 'Contact', '$location', '$cookies', function ContactFormCtrl($routeParams, Contact, $location, $cookies) {
        var self = this;

        self.contact = Contact.get();
        self.step = 'start';
        self.disable_btn = false;

        self.next_step = function(step){
            self.step = step;
        }

        self.send_form = function(){
            self.disable_btn = true;
            self.contact.$save(
                function(response){
                    self.step = 'complete';
                    self.disable_btn = false;
                    ym(44803777, 'reachGoal', 'SENT_MESSAGE');
                },
                function(response){
                    self.errors = response.data;
                    self.disable_btn = false;
                }
            );
        }

    }]
})
.component('lesspricemessage', {
    templateUrl: angularTemplatesBase+'contacts/lessprice-form.template.html?1',
    controller: ['$routeParams', 'ContactPrice', '$location', '$cookies',
        function LessPriceFormCtrl($routeParams, ContactPrice, $location, $cookies) {
        var self = this;

        self.contact = ContactPrice.get();
        self.step = 'start';
        self.disable_btn = false;

        self.next_step = function(step){
            self.step = step;
        }

        self.send_form = function(){
            self.disable_btn = true;
            self.contact.$save(
                function(response){
                    self.step = 'complete';
                    self.disable_btn = false;
                    ym(44803777, 'reachGoal', 'SENT_MESSAGE');
                },
                function(response){
                    self.errors = response.data;
                    self.disable_btn = false;
                }
            );
        }

    }]
})
.component('callmeform', {
    templateUrl: angularTemplatesBase+'contacts/callme.template.html?2',
    controller: ['$routeParams', 'CallMe', '$location', '$cookies', function CallFormCtrl($routeParams, CallMe, $location, $cookies) {
        var self = this;

        self.contact = CallMe.get();
        self.step = 'start';
        self.disable_btn = false;

        self.next_step = function(step){
            self.step = step;
        }

        self.send_form = function(){
            self.disable_btn = true;
            self.contact.$save(
                function(response){
                    self.step = 'complete';
                    self.disable_btn = false;
                    ym(44803777, 'reachGoal', 'SENT_MESSAGE');
                },
                function(response){
                    self.errors = response.data;
                    self.disable_btn = false;
                }
            );
        }

    }]
});